import { SET_SELECT_APOB_SELLER } from '../types';

export const setApobSeller =
  ({ apobSupplierID, isIrnNeeded, isClearTaxInvoice }) =>
  async (dispatch) => {
    dispatch({
      type: SET_SELECT_APOB_SELLER,
      apobSupplierID,
      isIrnNeeded,
      isClearTaxInvoice,
    });
  };
